import { isValid } from 'date-fns';

function isDateValid(date, minYear = 1900) {
	return date !== null && isValid(date) && date.getFullYear() > minYear;
}

export default isDateValid;
